import { createFileRoute } from '@tanstack/react-router';

type Search = {
  showPreview?: boolean;
  downloadPDF?: boolean;
};
/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/forms/builder_/$id')({
  validateSearch: (search: Search): Search => {
    return {
      showPreview: search.showPreview ? true : undefined,
      downloadPDF: search.downloadPDF ? true : undefined,
    };
  },
});
